<style scoped>
.total_debit_credit{
    font-weight: bold;
}
</style>


<template>
    <div>
        <b-overlay :show="showoverlay" rounded="sm">
            <!-- alpha fix- added class border to table to show border in detail report                                     -->
           <table class="table dataTable border">
                <thead>
                    <tr class="table-head">
                        <th v-for="detreport_column in detreportColumns" :key="detreport_column.name"><span>{{detreport_column.label}}</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="hover-bg table-row border-bottom mx-2" v-for="dreport in detreports" :key="dreport.id">
                        <td v-if="dreport.payroll_components">{{dreport.payroll_components}}</td>
                        <td v-if="dreport.payroll_components">{{dreport.name}}</td>
                        <td v-if="dreport.payroll_components">{{dreport.code}}</td>
                        <td v-if="dreport.payroll_components">{{dreport.gl_account_name}}</td>
                        <td v-if="dreport.payroll_components">{{dreport.gl_account_code}}</td>
                        <!-- alpha fix- added class text-right to show total debit and credit in right alignment -->
                        <td class="text-right" v-if="dreport.payroll_components">{{dreport.debit}}</td>
                        <td class="text-right" v-if="dreport.payroll_components">{{dreport.credit}}</td>
                    </tr>
                    <tr class="total_debit_credit">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <!-- alpha fix- added class text-right to show total debit and credit in right alignment -->
                        <td class="text-right">{{total_dc.debit}}</td>
                        <td class="text-right">{{total_dc.credit}}</td>
                    </tr>
                </tbody>
            </table>
        </b-overlay>
    </div>
</template>
<script>
import VeeValidate from 'vee-validate';
    export default {
        name: 'DetailReport',
        props:  [ 'payrun_id', 'total_dc' ],

    data() {
        let detreportColumns = [
            {label: 'Payroll Components', name:'payrollcomponents'},
            {label: 'Cost Center Name', name: 'cost_center_name'},
            {label: 'Cost Center Code', name: 'cost_center_code'},
            {label: 'GL Account Name', name: 'GLAccountName'},
            {label: 'GL Account Code', name: 'GLAccountCode'},
            {label: 'Debit', name: 'Debit'},
            {label: 'Credit', name: 'Credit'},
        ];

      return {
        detreportColumns: detreportColumns,
      }
    },
    created() {
        this.detreports = this.payrun_id;
        this.total_dc = this.total_dc;
    },
  }
</script>
